import { FieldName } from "../VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";

export const readableFieldName = {
  [FieldName.SelfReportedGrossIncomeToRentRatio]: "Gross income to rent",
  [FieldName.SelfReportedGrossIncome]: "Gross income",
  [FieldName.DebtToSelfReportedGrossIncome]: "Debt to gross income",

  [FieldName.GrossIncomeToRentRatio]: "Gross income to rent",
  [FieldName.GrossIncome]: "Gross income",
  [FieldName.NetIncome]: "Net income",
  [FieldName.DebtToNetIncome]: "Debt to net income",
  [FieldName.DebtToGrossIncome]: "Debt to gross income",
  [FieldName.IncomeDocumentFraudCheck]: "Income documents fraud risk detected",

  [FieldName.NoCreditScore]: "No credit score",
  [FieldName.CreditScore]: "Credit score",
  [FieldName.PastDueAccount]: "Past due accounts",
  [FieldName.UnpaidCollectionsBalance]: "Balance past due",
  [FieldName.CollectionsBalance]: "Balance of collections",
  [FieldName.BankruptcyRecords]: "Bankruptcy records",

  [FieldName.HousingCourtRecords]: "Housing court records",

  [FieldName.SexOffenderCheck]: "Sex offender convictions",
  [FieldName.OfacRecords]: "Sanctions (OFAC) convictions",
  [FieldName.FelonyRecords]: "Felony convictions",
  [FieldName.MisdemeanorRecords]: "Misdemeanor convictions",
  [FieldName.OtherCriminalRecords]: "Other criminal convictions",
  [FieldName.AllCriminalRecords]: "All criminal convictions"
} as const;

export const readableFieldSubtitle = {
  [FieldName.SelfReportedGrossIncomeToRentRatio]: "(Self-attested income)",
  [FieldName.SelfReportedGrossIncome]: "(Self-attested income)",
  [FieldName.DebtToSelfReportedGrossIncome]: "(Self-attested income)",
  [FieldName.GrossIncomeToRentRatio]: "(Verified income)",
  [FieldName.GrossIncome]: "(Verified income)",
  [FieldName.NetIncome]: "(Verified income)",
  [FieldName.DebtToNetIncome]: "(Verified income)",
  [FieldName.DebtToGrossIncome]: "(Verified income)"
};
